import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiPage, PagesApi, RouterApi } from '@tytapp/api';
import { ApiNotFoundError } from '@tytapp/api/requester';
import { UserService } from '@tytapp/user';
import { firstValueFrom } from 'rxjs';
import { ContentBlock } from './content-block';
import { Base64 } from '@tytapp/common';

@Component({
    selector: 'tyt-content-customizable-c2a',
    template: `
        @if (user?.staff && !hidden) {
            <div class="alert alert-info">
                <a class="close-button" href="javascript:;" mat-icon-button (click)="close()" matTooltip="Hide for now">
                    <mat-icon>close</mat-icon>
                </a>

                <strong>This content is customizable</strong>
                <p>
                    You are viewing the default version of this page.
                    This page has been enabled for customization via
                    the Pages content management system.
                </p>

                @if (page) {
                    <p>A draft version of this page exists. When the page
                        is published, the content will appear here.</p>

                    <a routerLink="/pages/edit/{{ page.id }}" mat-raised-button>Edit Draft</a>
                } @else {

                    <button mat-raised-button (click)="generatePage()">Customize</button>
                }

                <br/>
                <br/>

                <div class="indicator" matTooltip="These controls are only shown to TYT staff members with permission to edit the home page">
                    <mat-icon>lock</mat-icon>
                    Staff only
                </div>
            </div>
        }
    `,
    styles: `
        div.alert {
            position: relative;
        }

        .close-button {
            position: absolute;
            right: 0;
            top: 0;
        }
    `
})
export class ContentCustomizableC2aComponent {
    private userService = inject(UserService);
    private routerApi = inject(RouterApi);
    private pagesApi = inject(PagesApi);
    private router = inject(Router);
    private base64 = inject(Base64);

    hidden = false;

    close() {
        this.hidden = true;
    }

    @Input({ required: true })
    url: string;

    @Input({ required: true })
    pageTitle: string;

    @Input({ required: true })
    description: string;

    @Input({ required: true })
    summary: string;

    @Input({ required: true })
    includeInSearch: boolean;

    @Input()
    blocks: ContentBlock[];

    page: ApiPage;

    get user() {
        return this.userService.user;
    }

    generatePage() {
        this.router.navigate(['/pages/edit/new'], {
            queryParams: {
                blocks: this.base64.encode(JSON.stringify(this.blocks)),
                title: `${this.pageTitle}`,
                description: this.description,
                summary: this.summary,
                url: this.url,
                include_in_search: this.includeInSearch ? '1' : '0'
            },
            queryParamsHandling: 'merge'
        });
    }

    async ngOnInit() {
        try {
            let route = await firstValueFrom(this.routerApi.getRoute(this.url));
            if (route.type === 'CMS::Page') {
                this.page = await firstValueFrom(this.pagesApi.getPage(route.uuid));
            }
        } catch (e) {
            if (e instanceof ApiNotFoundError)
                return;

            throw e;
        }
    }
}